import { render, staticRenderFns } from "./4_event.vue?vue&type=template&id=0d2a9486&scoped=true&"
import script from "./4_event.vue?vue&type=script&lang=js&"
export * from "./4_event.vue?vue&type=script&lang=js&"
import style0 from "./4_event.vue?vue&type=style&index=0&id=0d2a9486&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d2a9486",
  null
  
)

export default component.exports